import { confirmDialog } from "primereact/confirmdialog";
import {
  deleteMappedUser,
  getAllMappedUsers,
  getMappedUser,
} from "../../services/ValitanApiService";
import { enqueueSnackbar } from "notistack";
import { createMappedUser } from '../../services/ValitanApiService';


// Fetch all mapped users (project-user mappings)
export const getMappedUsers = async (page = 0, size = 10) => {
  try {
    const response = await getAllMappedUsers(page, size);
    const apiData = response.data?.data;

    if (response.status === 200 && apiData?.content) {
      return {
        mappedUsers: apiData.content,
        paginationInfo: {
          totalElements: apiData.total_elements,
          totalPages: apiData.total_pages,
          pageNumber: apiData.number,
          pageSize: apiData.size,
          sort: apiData.sort,
        },
      };
    } else {
      enqueueSnackbar("Failed to fetch mapped users.", { variant: "error" });
      return { mappedUsers: [], paginationInfo: {} };
    }
  } catch (error) {
    enqueueSnackbar("Error fetching mapped users. Please try again.", {
      variant: "error",
    });
    return { mappedUsers: [], paginationInfo: {} };
  }
};

// Delete a project-user mapping by its ID
export const deleteAMappedUser = async (id, loadMappedUsers) => {
  try {
    const response = await deleteMappedUser(id);
    if (response.status === 200 || response.status === 204) {
      enqueueSnackbar("Mapping deleted successfully", { variant: "success" });
      await loadMappedUsers();
    } else {
      enqueueSnackbar("Failed to delete mapping.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Error deleting mapping. Please try again.", {
      variant: "error",
    });
    console.error(error);
  }
};


// Show confirmation dialog before deleting mapping
export const confirmDelete = (id, loadMappedUsers) => {
  confirmDialog({
    message: "Are you sure you want to unmap this user from the project?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteAMappedUser(id, loadMappedUsers),
    reject: () => { },
  });
};

// View a single mapping's details (for future edit functionality)
export const viewMappedUserDetails = async (
  id,
  setLoading,
  setUserId,
  setProjectId,
  setModalOpen
) => {
  setLoading(true);
  try {
    const response = await getMappedUser(id);
    if (response.status === 200 && response.data) {
      const mapping = response.data;
      setUserId(mapping.userId);
      setProjectId(mapping.projectId);
      setModalOpen(true);
    } else {
      enqueueSnackbar("Failed to fetch mapping details.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Error fetching mapping details. Please try again.", {
      variant: "error",
    });
    console.error(error);
  } finally {
    setLoading(false);
  }
};

// Validate form input
export const validateMappingForm = (projectId, userId, setErrors) => {
  const errorsCopy = { projectId: "", userId: "" };
  let valid = true;

  if (!projectId) {
    errorsCopy.projectId = "Project is required";
    valid = false;
  }

  if (!userId) {
    errorsCopy.userId = "User is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};

// Create a new project-user mapping
export const createProjectUserMapping = async (
  event,
  userId,
  projectId,
  isCurrent,
  loadMappedUsers,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (!validateMappingForm(projectId, userId, setErrors)) {
    return;
  }

  try {
    const response = await createMappedUser({ userId, projectId, isCurrent });
    if (response.status === 200 || response.data?.status === "success") {
      enqueueSnackbar("Mapping created successfully", { variant: "success" });
      toggleModal();
      await loadMappedUsers();
    } else {
      enqueueSnackbar("Failed to create mapping.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Error creating mapping. Please try again.", {
      variant: "error",
    });
    console.error(error);
  }
};

